module.exports = __webpack_public_path__ + "5213d0d55476534deec348043318ba24.svg";